import { AxiosInstance } from 'axios';
import { MaybeString } from './types';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

type DoesCustomerExist = (email: string) => Promise<ApiResponse<{ customer_id: MaybeString }>>;

const doesCustomerExist = (api: AxiosInstance): DoesCustomerExist => {
  return async (email: string) => {
    return apiRequest<{ customer_id: MaybeString }>(api, {
      method: 'GET',
      url: `/api/custom-booking/customer/${email}`
    });
  }
}

export default doesCustomerExist;